module.exports = __webpack_public_path__ + "static/img/zx-zxzx-icon.27bfdf27.png";